import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import styles from "./Dialog.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

// import Draggable from 'react-draggable';

// function PaperComponent(props) {
//   return (
//     <Draggable
//       handle="#draggable-dialog-title"
//       cancel={'[class*="MuiDialogContent-root"]'}
//     >
//       <Paper {...props} />
//     </Draggable>
//   );
// }

export default function DraggableDialog(props) {
  const {
    openDialog,
    title,
    body,
    actionButton,
    handleCloseDialog,
    handleConfirmCloseDialog,
  } = props;

  return (
    <div>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        // PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        className={styles.DialogMainContainer}
      >
        <div className={styles.Dialog}>
          <div className={styles.DialogButtonClose}>
            <Button autoFocus onClick={handleCloseDialog}>
              <CloseRoundedIcon />
            </Button>
          </div>
          <div
            className={styles.DialogContainer}
            style={{ width: props.width, padding: props.padding, minHeight:props.Height }}
          >
            <div className={styles.ModalTitle}>
              {title}
            </div>
            <div className={styles.ModalBody}>
              {body}
            </div>
            <div className={styles.DialogButton}>
              <Button
                className={styles.ContinueButton}
                onClick={handleConfirmCloseDialog}
                sx={{ margin: `${props.actionButtonMargin} !important` }}
              >
                {actionButton}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
